import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    token: null,
    userName: null,
    emailId: null,
    isLoggedOut: false,
    isInternalUser: false
};


export const OktaAuthSlice = createSlice({
    name: 'oktaAuth',
    initialState,
    reducers: {
        setAuthToken: (state, action) => {
            sessionStorage.setItem("accessToken", action.payload);
            state.token = action.payload
        },
        setUserName: (state, action) => {
            state.userName = action.payload
        },
        setUserEmailId: (state, action) => {
            state.emailId = action.payload
        },
        setUserLoggedOut: (state, action) => {
            state.isLoggedOut = action.payload
        },
        setIsInternalUser: (state, action) => {
            state.isInternalUser = action.payload
        },
        clearAuthStore: (state) => {
            state.token = null;
            state.userName = null;
            state.emailId = null;
            state.isLoggedOut = true;
            state.isInternalUser = false;
        }
    }
});

export const { setAuthToken, setUserName, setUserEmailId, clearAuthStore, setUserLoggedOut, setIsInternalUser } = OktaAuthSlice.actions;

export const getAuthToken = (state: any) => state.oktaAuth.token;

export const getUserName = (state: any) => state.oktaAuth.userName;

export const getUserEmail = (state: any) => state.oktaAuth.emailId;

export const getUserLoggedOutStatus = (state: any) => state.oktaAuth.isLoggedOut;

export const getUserRoleTypeStatus = (state: any) => state.oktaAuth.isInternalUser;

export default OktaAuthSlice.reducer;